import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye, faTrash,faDownload } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { Box, CircularProgress, MenuItem, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { useNavigate, useParams } from 'react-router-dom';

import { IoArrowBack } from "react-icons/io5";

import { useState ,useEffect, useMemo } from "react";

import TablePaginationActions from '../../../../base-components/TablePaginationActions';
import ExportDropdownMenu from '../../../../base-components/ExportDropdownMenu';
import { Pie } from 'react-chartjs-2';
import { Report } from './Report';
import dayjs from 'dayjs';
import { isDynamicStaffRole } from '../../../../utils/roleAccess';
import { PageHeader } from "../../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;
function ExpectedIncomeReport() {
    const navigate = useNavigate()
    const {income} = useParams()
    //states for this page
    const [loading , setLoading] = useState(false)
    const [vouchers , setVouchers] = useState([])
    //roles and permission states
    const [role , setRole] = useState('')
    const [location_id , setLocationID] = useState('')
    const [company_id , setCompanyID] = useState('')
    const [member_id , setMemberID] = useState('')
    //pagintion states
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page , setPage ] = useState(0)
    const [filtered_vouchers, setFilteredVouchers] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState("All");
    
    const [VoucherType, setSubscriptionType] = useState("");
    const [paymentFromDate, setPaymentFromDate] = useState(""); 
    const [paymentToDate, setPaymentToDate] = useState("");  
    const [dueFromDate, setDueFromDate] = useState("");
    const [dueToDate, setDueToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState(""); 
    const [totalRecieved , setTotalRecieved] = useState(0)
    const [totalDiscount , setTotalDiscount] = useState(0)

    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
            setMemberID(session.user.member_id)
        }
        else {
            navigate('/login');
        }
    },[])

    useEffect(() => {
        setLoading(true)
        if(role) {
        getVouchers()
        setTimeout(()=> {
            setLoading(false)
        } , 1000)
        }
    }, [role]);

    const getVouchers = async () => {
        if(!role) return;
        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = ``;
        } else if (role === 'Admin') {
            endpoint = `voucher/getVouchersByCompanyID/${company_id}`;
        } else if (role === 'ClubAdmin') {
            endpoint = `voucher/getVouchersByLocationID/${location_id}`;
        } else if (isDynamicStaffRole(role)) {
            endpoint = `voucher/getVouchersByLocationID/${location_id}`;
        }
        await fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            const startOfMonth = new Date();
            startOfMonth.setDate(1); // Set to the first day of the month
            startOfMonth.setHours(0, 0, 0, 0); // Reset time to start of the day
        
            const endOfMonth = new Date();
            endOfMonth.setMonth(endOfMonth.getMonth() + 1); // Move to next month
            endOfMonth.setDate(0); // Set to last day of current month
            endOfMonth.setHours(23, 59, 59, 999); // Set time to end of the day

            const allVouchers = data.vouchers;
            const thisMonthVouchers = allVouchers.filter(voucher => {
                const voucherDate = new Date(voucher.voucher_date);
                return voucherDate >= startOfMonth && voucherDate <= endOfMonth;
            });
            setVouchers(thisMonthVouchers)
            setFilteredVouchers(thisMonthVouchers)
        })
        .catch((error) => {
            console.log(error)
        });
    }
    console.log("id",vouchers)
    const paginatedVouchers = !filtered_vouchers || filtered_vouchers.length === 0 ?
    [] :
     rowsPerPage === -1
    ? filtered_vouchers // Show all if "All" option is selected
    : filtered_vouchers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
      const handleDownload=()=>{
          Report(filtered_vouchers)
      }

      // Detect if filters are applied  
      const hasFiltersApplied = useMemo(() => {
        return fromDate || toDate || searchQuery || status !== 'All' || VoucherType || paymentFromDate || paymentToDate || dueFromDate || dueToDate;
      }, [fromDate, toDate, searchQuery, status, VoucherType, paymentFromDate, paymentToDate, dueFromDate, dueToDate]);

      // Export handlers
      const handleExportAll = () => {
        Report(vouchers);
      };

      const handleExportWithFilters = () => {
        Report(filtered_vouchers);
      };

      const handleExportCurrentView = () => {
        const currentPageData = paginatedVouchers;
        Report(currentPageData);
      };
            const handleSearch = (search) => {
                  setSearchQuery(search);
                  let filteredvoucher = [];
                  if(search === '') {
                    setFilteredVouchers(vouchers);
                  }
                  else {
                    filteredvoucher  = vouchers.filter((voch) => 
                      (voch.invoice_no.toLowerCase()?.includes(search.toLowerCase())) || 
                      (voch.voucher_type.toLowerCase()?.includes(search.toLowerCase())) ||
                      (voch.member_id.member_id.toLowerCase()?.includes(search.toLowerCase())) ||
                      (voch.member_id.name.toLowerCase()?.includes(search.toLowerCase())) 
                    );
                    setFilteredVouchers(filteredvoucher);
                  }
              }; 

    const handleStatusChange = (value) => {
        setStatus(value);
        if(value === 'Paid'){
            setFilteredVouchers(vouchers.filter(voucher => voucher.invoice?.is_paid === true || voucher.receipt))
        }else if(value === 'Unpaid'){
            setFilteredVouchers(vouchers.filter(voucher => voucher.invoice?.is_paid === false))
        }else if(value === 'All') {
            setFilteredVouchers(vouchers)
        }
    }
  
    const handleFilter = () => {
        setLoading(true);
        let filtered = filtered_vouchers; 
        console.log(filtered);
    
        
        if (fromDate && toDate) {
            const startFilterDate = new Date(fromDate);
            const endFilterDate = new Date(toDate);
    
            filtered = filtered.filter(voucher => {
                const voucherDate = new Date(voucher.voucher_date);
                return voucherDate >= startFilterDate && voucherDate <= endFilterDate;
            });
        }
        if (paymentFromDate && paymentToDate) {
            const startPaymentDate = new Date(paymentFromDate);
            const endPaymentDate = new Date(paymentToDate);
        
            filtered = filtered.filter(voucher => {
                if(voucher.receipt){
                
                const paymentDate = voucher.voucher_date ? new Date(voucher.voucher_date) : null;
                    return  paymentDate >= startPaymentDate && paymentDate <= endPaymentDate;
                }else {
                    const paymentDate = voucher?.invoice?.payment_date ? new Date(voucher.invoice.payment_date) : null;
                    return paymentDate && paymentDate >= startPaymentDate && paymentDate <= endPaymentDate;
                }
            });
        }


        // null errror in the code  in check if condition is true working in hht null using
        
        // if (dueFromDate && dueToDate) {
        //     const startDueDate = new Date(dueFromDate);
        //     const endDueDate = new Date(dueToDate);
        
        //     filtered = filtered.filter(voucher => {
        //         const dueDate =  new Date(voucher.invoice.due_date);
        //         return dueDate && dueDate >= startDueDate && dueDate <= endDueDate;
        //     });
        // }


        if (dueFromDate && dueToDate) {
            const startDueDate = new Date(dueFromDate);
            const endDueDate = new Date(dueToDate);
        
            filtered = filtered.filter(voucher => {
                const invoiceDueDate = voucher?.invoice?.due_date ? new Date(voucher.invoice.due_date) : null;
                const receiptDueDate = voucher?.receipt?.due_date ? new Date(voucher.receipt.due_date) : null;
        
                console.log("Voucher ID:", voucher._id);
                console.log("Invoice Due Date:", invoiceDueDate);
                console.log("Receipt Due Date:", receiptDueDate);
                
                return (
                    (invoiceDueDate && invoiceDueDate >= startDueDate && invoiceDueDate <= endDueDate) ||
                    (receiptDueDate && receiptDueDate >= startDueDate && receiptDueDate <= endDueDate)
                );
            });
        }
        if (VoucherType) {
            filtered = filtered.filter(voucher => 
                voucher.voucher_type.toLowerCase() === VoucherType.toLowerCase()
            );
        }
    
        console.log("Filtered Vouchers:", filtered);
        setFilteredVouchers(filtered);
        
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    
      const handleClear = () => {
        setLoading(true); 
        setFilteredVouchers(vouchers); 
    
        
        setFromDate("");
        setToDate("");
        setStatus("");
       
        setSubscriptionType("");
        setDueFromDate("");
        setDueToDate("");
        setPaymentFromDate("");
        setPaymentToDate("");
    
        
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      };
  return (
    <>
        <div className="m-5 print:hidden">
          <PageHeader 
            title="Expected Income Report"
            actions={
              <ExportDropdownMenu
                onExportAll={handleExportAll}
                onExportWithFilters={handleExportWithFilters}
                onExportCurrentView={handleExportCurrentView}
                hasFiltersApplied={hasFiltersApplied}
              />
            }
          />
        </div>
            <div className='px-8 py-4'>
                <h1 className="text-2xl font-semibold text-[#97BBCD]">Statistics:</h1>
                <div className='flex items-center gap-2'>
                    <div className='w-4 h-4 bg-[#97BBCD]'></div>
                    <div className='text-lg'>Current Month Expected Income: {income}</div>
                </div>
            </div>
            {/* <div className="w-full my-3 mx-8">
                <Select value={status} onChange={(e) => handleStatusChange(e.target.value)}
                    className="w-[250px] bg-white h-9"
                    >
                    <MenuItem value={'All'}>All</MenuItem>
                    <MenuItem value={'Paid'}>Paid</MenuItem>
                    <MenuItem value={'Unpaid'}>Unpaid</MenuItem>
                </Select>
            </div> */}
        {
             loading ? (
                
                  <div className="flex justify-center items-center mt-20 relative">
                    {/* SVG Gradient Definition */}
                    <svg width="0" height="0">
                      <defs>
                        <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#D71920" />
                          <stop offset="100%" stopColor="#F7931E" />
                        </linearGradient>
                      </defs>
                    </svg>
            
                    {/* Circular Progress with Gradient Stroke */}
                    <CircularProgress
                      thickness={4}
                      size={35}
                      sx={{
                        'svg circle': {
                          stroke: 'url(#gradientColors)', // Apply gradient stroke
                        },
                      }}
                    />
                  </div>
                
              ) : (
                filtered_vouchers && filtered_vouchers.length !== 0 ? (     
            <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
                <Table>
                  <TableHead>
                      <TableRow >
                          <TableCell>Voucher No</TableCell>
                          <TableCell>Member Id</TableCell>
                          <TableCell>Member Name</TableCell>
                          <TableCell>Issue Date</TableCell>
                          <TableCell>Due Date</TableCell>
                          <TableCell>Due Amount</TableCell>
                          <TableCell>Discount</TableCell>
                          <TableCell>Payment Reference</TableCell>
                          <TableCell>Status</TableCell>
                          {/* <TableCell>Actions</TableCell> */}
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      paginatedVouchers.map((voucher , index) => (
                            voucher?.voucher_type === 'Invoice' ?
                                (<TableRow hover key={index}>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    <TableCell>{voucher?.member_id?.member_id}</TableCell>
                                    <TableCell>{voucher?.member_id?.name}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher.voucher_date).format("MMM DD, YYYY") : ''}</TableCell>
                                    <TableCell>{voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).format("MMM DD, YYYY") : ''}</TableCell>
                                    <TableCell>Rs {voucher?.invoice?.total_amount}</TableCell>
                                    <TableCell>{voucher?.invoice?.discount || 0}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    <TableCell>{voucher?.invoice?.payment_status || 'Expired'}</TableCell>
                                    {/* <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/voucher/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell> */}
                                </TableRow>) : (
                                    voucher?.voucher_type === 'Receipt' ? 
                                    (<TableRow>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    <TableCell>{voucher?.member_id.member_id}</TableCell>
                                    <TableCell>{voucher?.member_id.name}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format("MMM DD, YYYY") : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format("MMM DD, YYYY") : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format("MMM DD, YYYY") : ''}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || '- - - '}</TableCell>
                                    <TableCell>{voucher?.receipt?.discount || 0}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    <TableCell>Paid</TableCell>
                                    {/* <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/recipt/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell> */}
                                    </TableRow>): null
                                )
                                    
                            ))
                    }
                  </TableBody>
                  <TableFooter>
                      <TableRow>
                      <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={12}
                          count= {filtered_vouchers.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                              select: {
                              inputProps: {
                                  'aria-label': 'rows per page',
                              },
                              native: true,
                              },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          />
                      </TableRow>
                  </TableFooter>
              </Table>
            </Box>
            ) : (
              <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
              </div>
            )
        )
          }
    </>
  )
}

export default ExpectedIncomeReport